import React from "react";
import HeaderToolbar, { HeaderToolbarProps } from "./HeaderToolbar";

export type ProjectPanelHeaderToolbarProps<T> = Omit<HeaderToolbarProps<T>, "isInProjectlist" | "isFileList">;

function ProjectPanelHeaderToolbar<T>(props: ProjectPanelHeaderToolbarProps<T>) {
  const className = ["project-panel-header-toolbar", props.className].filter(Boolean).join(" ");

  return <HeaderToolbar {...props} className={className} isInProjectlist={true} isFileList={false} />;
}

export default ProjectPanelHeaderToolbar;
